const toText = (value) => (typeof value === 'string' ? value.trim() : '')

const isAxiosStatusMessage = (value) =>
  /^Request failed with status code \d+$/i.test(value)

export function getErrorMessage(error, fallback = 'Something went wrong.') {
  const backend = error?.response?.data || error?.data
  const details = Array.isArray(backend?.data)
    ? backend.data
    : Array.isArray(backend)
      ? backend
      : []

  if (details.length > 0) {
    const detailMessage = toText(details[0]?.message)
    if (detailMessage) return detailMessage
  }

  const backendMessage = toText(backend?.message)
  if (backendMessage && backendMessage.toLowerCase() !== 'validation failed') {
    return backendMessage
  }

  if (backendMessage) return backendMessage

  const localMessage = toText(error?.message)
  if (localMessage && !isAxiosStatusMessage(localMessage)) return localMessage

  return fallback
}
